import React from 'react';
import {Progress, VStack, Text, HStack } from '@chakra-ui/react';

function PreLoader() {
  return (
    <VStack
      w='100%'
      h='100vh'
      spacing='4'
      justifyContent='center'
      alignItems='center'
    >
      
      <Progress size='xs' w='40%' colorScheme='brown' isIndeterminate />
      <HStack>
        <Text fontWeight='300' color='gray.400'>
          search less, shop more
        </Text>
      </HStack>
    </VStack>
  );
}

export default PreLoader;
